<template>
  <div>
    <!-- <Logodia></Logodia> -->
    <!-- <div class="zhanwei"></div> -->

    <div class="lg">
      <div class="mainbox">
        <div class="maintitle">
          购物车(<span class="color986">{{ allnum }}</span>)
        </div>
        <div class="mainitembox" v-for="item in cartList" :key="item.id">
          <div class="checkcionbox" @click="changeChecked(item)">
            <img v-if="item.isCkecked == true" class="ckeckicon" src="../../assets/imgs/xuanzhong@3x.png" alt="" />
          </div>
          <div>
            <img @click="toCommoditydetails(item)" class="mainimg" :src="item.productMainImage" alt="" />
          </div>
          <div class="mainiteninfobox">
            <div class="flexboxtwo">
              <div class="infonamebox" @click="toCommoditydetails(item)">
                {{ item.productName }}
              </div>
              <div class="infotitlebox">{{ item.productBrief }}</div>
              <div class="skuinfo">
                <div class="skuinfoitem" v-for="(ctem, index) in item.skuVal" :key="index">
                  {{ ctem }}
                </div>
                <div class="skuinfoitem" style="color: #000000" v-if="item.skuVal" @click="openEditPop(item, 'mobile')">
                  修改 <span v-if="item.skuTotalUnit<item.num" style="color: #ff0000">（库存不足）</span>
                </div>
              </div>
              <div v-if="item.linePrice">
                <span style="text-decoration: line-through; margin-right: 10px">￥{{ item.linePrice }}</span>
                <span v-if="item.discountRate" style="color: #d62938">（{{ item.discountRate * 10 }}折）</span>
                <span v-if="item.discountAmount" style="color: #d62938">（优惠{{ item.discountAmount }}元）</span>
              </div>
              <div class="flexbox">
                <div class="skuinfoprice" v-if="item.linePrice">

                  <span style="color: #d62938">￥{{ item.unitPrice }}</span>

                </div>
                <div class="skuinfoprice" v-else>￥{{ item.unitPrice }}</div>
                <div>
                  <van-stepper :value="item.num" disable-input async-change @change="onChange($event, item)" min="1"
                    max="10" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="zhanwei"></div>
      <div class="footbox">
        <div class="footmainbox">
          <div>
            <div class="checkcionbox inlineblock" @click="changeAllCheck">
              <img v-if="allChecked" class="ckeckicon" src="../../assets/imgs/xuanzhong@3x.png" alt="" />
            </div>
            <div class="inlineblock quanxuanicon">全选</div>
          </div>
          <div class="deltext" @click="delCart">删除</div>
          <div>
            <span class="zhifulable">合计支付：</span>
            <span class="pricefont">￥{{ allPrice }}</span>
          </div>
          <div class="buybtn" @click="toBuyfromCart">结算({{ allnumber }})</div>
        </div>
      </div>
    </div>

    <van-popup v-model="showEditPop" round closeable close-icon-position="top-left" safe-area-inset-bottom
      position="bottom" :style="{ height: '60%' }">
      <div class="editpoptitle">修改参数</div>

      <div class="commodityInfobox">
        <div class="commoditytitlebox">{{ productInfo.productName }}</div>
        <div class="commoditynamebox">{{ productInfo.productBrief }}</div>
        <div class="commoditytagbox">
          <div class="commoditytag" v-if="productInfo.isQuantity == 1">
            限量款
          </div>
        </div>

        <div class="pricebox">
          <div class="pricelablebox">价格</div>
          <div class="pricenumbox" v-if="productInfo.linePrice">
            <span style="text-decoration: line-through; margin-right: 10px">￥{{ productSkuInfo.linePrice }}</span>
            <span style="color: #d62938">
              ￥{{ productSkuInfo.skuUnitPrice || productInfo.unitPrice }}</span>
            <span v-if="productSkuInfo.discountRate" style="color: #d62938">（{{ productSkuInfo.discountRate * 10
              }}折）</span>
            <span v-if="productSkuInfo.discountAmount" style="color: #d62938">（优惠{{ productSkuInfo.discountAmount
              }}元）</span>
          </div>
          <div class="pricenumbox" v-else>
            ￥{{ productSkuInfo.skuUnitPrice || productInfo.unitPrice }}
          </div>
          <div class="pricenumbox" style="margin-left: 10px; color: #ff0000; font-weight: 400"
            v-if="productSkuInfo.id && productSkuInfo.skuTotalUnit <= 0">
            已售罄
          </div>
        </div>
        <div class="skubox">
          <div class="marginbuttom10" v-for="item in productInfo.sku" :key="item.id">
            <div class="pricelablebox">{{ item.name }}</div>
            <div class="inlinerightbox">
              <el-select size="small" v-model="item.checkedId" placeholder="请选择" @change="changeSkuSelect"
                :popper-append-to-body="false">
                <el-option v-for="ctem in item.val" :key="ctem.id" :disabled="ctem.skuTotalUnit == 0"
                  :label="ctem.skuValue" :value="ctem.id"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>

      <div class="commodityInfobox statelable">
        提示：如果需替换的商品已售罄，请通过右下角的客服系统或者客服电话联系客服，确认后再进行购买。否则可能无法发货。
      </div>

      <div class="editbtnbox" @click="submitEdit">确认修改</div>
    </van-popup>
    <el-dialog style="box-sizing: border-box" title="修改参数" :visible.sync="showEditPoppc" width="500px">
      <div style="background-color: #eeeee2; padding-bottom: 20px">
        <div>
          <el-form size="mini" label-width="100px">
            <el-form-item label="商品名称">
              <div style="font-family: PingFang; font-weight: bold; color: #666666">
                {{ productInfo.productName }}
              </div>
            </el-form-item>
            <el-form-item label="款式">
              <div v-if="productInfo.isQuantity == 1">限量款</div>
              <div v-else>普通款</div>
            </el-form-item>
            <el-form-item label="价格" v-if="productInfo.linePrice">
              <span style="text-decoration: line-through; margin-right: 10px">￥{{ productSkuInfo.linePrice }}</span>
              <span style="color: #d62938">
                ￥{{
                productSkuInfo.skuUnitPrice || productInfo.unitPrice
                }}</span>
              <span v-if="productSkuInfo.discountRate" style="color: #d62938">（{{ productSkuInfo.discountRate * 10
                }}折）</span>
              <span v-if="productSkuInfo.discountAmount" style="color: #d62938">（优惠{{ productSkuInfo.discountAmount
                }}元）</span>
            </el-form-item>
            <el-form-item label="价格" v-else>
              ￥{{ productSkuInfo.skuUnitPrice || productInfo.unitPrice }}
            </el-form-item>
            <el-form-item label="库存">
              <div style="color: #ff0000" v-if="productSkuInfo.id && productSkuInfo.skuTotalUnit <= 0">
                已售罄
              </div>
              <div v-else>库存充裕</div>
            </el-form-item>
            <el-form-item :label="item.name" v-for="item in productInfo.sku" :key="item.id">
              <el-select v-model="item.checkedId" @change="changeSkuSelect">
                <el-option v-for="ctem in item.val" :key="ctem.id" :label="ctem.skuValue" :value="ctem.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提示">
              <div class="">
                如果需替换的商品已售罄，请通过右下角的客服系统或者客服电话联系客服，确认后再进行购买。否则可能无法发货。
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="diafooterbtn">
          <el-button @click="cleanFn" style="width: 84px; margin-right: 10%" size="small" type="primary"
            plain>取消</el-button>
          <el-button style="width: 84px" @click="submitEdit" size="small" type="primary">保存</el-button>
        </div>
      </div>
    </el-dialog>

    <div class="zrl zrlbox">
      <div class="zrlmainbox">
        <div class="zrlmaintitle">
          购物车(<span class="zrlcolor986">{{ allnum }}</span>)
        </div>
        <div class="zrlmainitembox" v-for="item in cartList" :key="item.id">
          <div class="zrlcheckcionbox" @click="changeChecked(item)">
            <img v-if="item.isCkecked == true" class="zrlckeckicon" src="../../assets/imgs/xuanzhong@3x.png" alt="" />
          </div>
          <div>
            <img @click="toCommoditydetails(item)" class="zrlmainimg" :src="item.productMainImage" alt="" />
          </div>
          <div class="zrlmainiteninfobox">
            <div class="zrlflexboxtwo">
              <div class="zrlinfonamebox" @click="toCommoditydetails(item)">
                {{ item.productName }}
              </div>
              <div class="zrlinfotitlebox">{{ item.productBrief }}</div>
              <div class="zrlskuinfo">
                <div class="zrlskuinfoitem" v-for="(ctem, index) in item.skuVal" :key="index">
                  {{ ctem }}
                </div>
                <div class="zrlskuinfoitem" style="color: #000000; cursor: pointer" v-if="item.skuVal"
                  @click="openEditPop(item, 'pc')">
                  修改 <span v-if="item.skuTotalUnit<item.num" style="color: #ff0000">（库存不足）</span>
                </div>
              </div>
              <div class="zrlflexbox">
                <div class="zrlskuinfoprice" v-if="item.linePrice">
                  <span style="text-decoration: line-through; margin-right: 10px">￥{{ item.linePrice }}</span>
                  <span style="color: #d62938">
                    ￥{{ item.skuUnitPrice || item.unitPrice }}</span>
                  <span v-if="item.discountRate" style="color: #d62938">（{{ item.discountRate * 10 }}折）</span>
                  <span v-if="item.discountAmount" style="color: #d62938">（优惠{{ item.discountAmount }}元）</span>
                </div>
                <div class="zrlskuinfoprice" v-else>￥{{ item.unitPrice }}</div>
                <div>
                  <van-stepper :value="item.num" disable-input async-change @change="onChange($event, item)" min="1"
                    max="10" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="zrlzhanwei"></div>
      <div class="zrlfootbox">
        <div class="zrlfootmainbox">
          <div>
            <div class="zrlcheckcionbox zrlinlineblock" @click="changeAllCheck">
              <img v-if="allChecked" class="zrlckeckicon" src="../../assets/imgs/xuanzhong@3x.png" alt="" />
            </div>
            <div class="zrlinlineblock zrlquanxuanicon">全选</div>
          </div>
          <div class="zrldeltext" @click="delCart">删除</div>
          <div>
            <span class="zrlzhifulable">合计支付：</span>
            <span class="zrlpricefont">￥{{ allPrice }}</span>
          </div>
          <div class="zrlbuybtn" @click="toBuyfromCart">
            结算({{ allnumber }})
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    cartList_api,
    upCartNum_api,
    delCart_api,
    carUpdateProductSku_api,
  } from "../../apis/cart";
  import { productInfo_api, productSkuPrice_api } from "../../apis/product";
  import { buyInfoTwo_api } from "../../apis/order";
  import Logodia from "../../components/Logodia.vue";
  export default {
    components: {
      Logodia,
    },
    data() {
      return {
        value: 1,
        searchData: {
          pageNumber: 1,
          pageSize: 999,
        },
        cartList: [],
        allnum: 0,
        allChecked: false,
        allPrice: 0,
        allnumber: 0,
        productId: 0,
        carProductId: 0,
        productInfo: {},
        productSkuInfo: {},
        productSkuIds: "",
        showEditPop: false,
        showEditPoppc: false,
        shebeiType: "",
        testsku: [
          { id: 1, skuValue: "111" },
          { id: 2, skuValue: "222" },
          { id: 3, skuValue: "333" },
        ],
      };
    },
    created() {
      this.getCartList();
    },
    methods: {
      async getCartList() {
        let { code, data } = await cartList_api(this.searchData);
        if (code == 0) {
          this.cartList = data.rows;
          this.allnum = data.total;
          this.cartList.forEach((item) => {
            this.$set(item, "isCkecked", false);
          });
        }
      },
      async toBuyfromCart() {
        if (this.allnumber == 0) {
          this.$toast("请选择商品");
        } else {
          let idsList = [];
          this.cartList.forEach((item) => {
            if (item.isCkecked == true) {
              idsList.push(item.id);
            }
          });
          let ids = idsList.join(",");

          let { code, data } = await buyInfoTwo_api({
            spids: ids,
          });
          if (code == 0) {
            this.$router.push(
              {
                path: "/buyfromcart",
                query: {
                  type: "cart",
                  spids: ids,
                },
              },
              () => { }
            );
          }
        }
      },
      delCart() {
        if (this.allnumber == 0) {
          this.$toast("请选择商品");
        } else {
          this.$dialog
            .confirm({
              message: "确定要删除吗？",
            })
            .then(() => {
              this.delCartFn();
            });
        }
      },
      async delCartFn() {
        let idsList = [];
        this.cartList.forEach((item) => {
          if (item.isCkecked == true) {
            idsList.push(item.id);
          }
        });
        let ids = idsList.join(",");
        let { code, data } = await delCart_api({
          id: ids,
        });
        if (code == 0) {
          this.$toast.success("已删除");
          this.getCartList();
          this.getAllPrice();
        }
      },
      changeChecked(item) {
        console.log(item);
        // if (item.skuTotalUnit >= item.num) {
        //   item.isCkecked = !item.isCkecked;
        //   this.getAllPrice();
        // }
        item.isCkecked = !item.isCkecked;
        this.getAllPrice();
      },
      changeAllCheck() {
        this.allChecked = !this.allChecked;
        if (this.allChecked) {
          this.cartList.forEach((item) => {
            // if (item.skuTotalUnit >= item.num) {
            //   item.isCkecked = true;
            // }
            item.isCkecked = true;
          });
        } else {
          this.cartList.forEach((item) => {
            item.isCkecked = false;
          });
        }
        this.getAllPrice();
      },
      async onChange(val, item) {
        let { code, data } = await upCartNum_api({
          id: item.id,
          num: val,
        });
        if (val > item.skuTotalUnit) {
          item.isCkecked = false
          
          this.$toast("库存不足")
          return 
        }

        if (code == 0) {
          item.num = val;
        } else {
          item.isCkecked = false
          this.$toast("超出购买限制");

        }
        this.getAllPrice();
      },
      getAllPrice() {
        this.allPrice = 0;
        this.allnumber = 0;
        this.cartList.forEach((item) => {
          if (item.isCkecked) {
            this.allnumber += item.num;
            this.allPrice += item.num * item.unitPrice;

          }
        });
        this.allPrice = this.allPrice.toFixed(2);
      },
      toCommoditydetails(item) {
        this.$router.push(
          {
            path: "/commoditydetails",
            query: {
              commodityId: item.productId,
            },
          },
          () => { }
        );
      },
      openEditPop(item, type) {
        this.shebeiType = type;
        this.productId = item.productId;
        this.carProductId = item.id;
        this.productInfo = {};
        this.productSkuInfo = "";
        this.getProductInfo();
      },
      getProductInfo() {
        productInfo_api({
          id: this.productId,
        }).then((res) => {
          this.productInfo = res.data;
          if (this.productInfo.isSkuEnabled == 1) {
            this.productInfo.sku.forEach((item) => {
              this.$set(item, "checkedId", item.val[0].id);
            });
            this.getProductSkuPrice();
          }
        });
      },
      async getProductSkuPrice() {
        let idsArr = [];
        this.productInfo.sku.forEach((item) => {
          idsArr.push(item.checkedId);
        });
        this.productSkuIds = idsArr.join(",");
        let { code, data } = await productSkuPrice_api({
          ids: this.productSkuIds,
        });
        if (code == 0) {
          this.productSkuInfo = data;
          if (this.shebeiType == "pc") {
            this.showEditPoppc = true;
          } else if (this.shebeiType == "mobile") {
            this.showEditPop = true;
          }
        }
      },
      changeSkuSelect() {
        this.getProductSkuPrice();
      },
      submitEdit() {

        if (this.productSkuInfo.skuTotalUnit <= 0) {
          this.$toast.fail("库存不足");
          return;
        }
        let idsArr = [];
        if (this.productInfo.isSkuEnabled == 1) {
          this.productInfo.sku.forEach((item) => {
            idsArr.push(item.checkedId);
          });
        }
        this.productSkuIds = idsArr.join(",");
        carUpdateProductSku_api({
          id: this.carProductId,
          skuids: this.productSkuIds,
        }).then((res) => {
          this.$toast.success("修改成功");
          this.showEditPop = false;
          this.showEditPoppc = false;
          this.getCartList();
        });
      },
      cleanFn() {
        this.showEditPoppc = false;
      },
    },
  };
</script>

<style lang="less" scoped>
  .zhanwei {
    width: 100%;
    height: 150px;
  }

  .logobox {
    width: 130px;
    height: 48px;
    margin: 0 auto;
  }

  .logoimg {
    width: 130px;
    height: 48px;
  }

  .categorybox {
    display: flex;
    flex-wrap: wrap;
    border-top: 1px solid #dddddd;
    margin-top: 30px;
  }

  .categoryitembox {
    width: 148px;
    height: 60px;
    // border-top: 1px solid #dddddd;
    border-right: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 60px;
    text-align: center;
  }

  .categoryitembox:nth-child(5n) {
    border-right: none;
  }

  .mainbox {
    margin: 0 auto;
    width: 690px;
    margin-top: 37px;
  }

  .maintitle {
    margin-bottom: 48px;
    font-size: 30px;
    font-family: PingFang;
    font-weight: bold;
    color: #333333;
  }

  .color986 {
    color: #986565;
  }

  .mainitembox {
    width: 648px;
    padding: 30px 20px;
    // background: #ffffff;
    // border: 1px solid #dddddd;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    border-top: 2px solid #222;
  }

  .checkcionbox {
    width: 32px;
    height: 32px;
    background: #dddddd;
    border-radius: 2px;
  }

  .ckeckicon {
    width: 32px;
    height: 32px;
  }

  .mainimg {
    width: 180px;
    height: 180px;
    border-radius: 5px;
    object-fit: cover;
  }

  .mainiteninfobox {
    width: 387px;
    min-height: 180px;
  }

  .infonamebox {
    font-size: 24px;
    font-family: PingFang;
    font-weight: bold;
    color: #666666;
  }

  .infotitlebox {
    font-size: 24px;
    font-family: PingFang;
    font-weight: 500;
    color: #000000;
  }

  .skuinfo {
    font-size: 24px;
    font-family: PingFang;
    font-weight: 500;
    color: #999999;
  }

  .skuinfoitem {
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;
  }

  .flexbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .skuinfoprice {
    font-size: 30px;
    font-family: PingFang;
    font-weight: 500;
    color: #000000;
  }

  .flexboxtwo {
    min-height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .footbox {
    width: 750px;
    height: 120px;
    background: #ffffff;
    box-shadow: 0px -1px 7px 0px rgba(235, 235, 236, 0.42);
    position: fixed;
    left: 0px;
    bottom: 0px;
    padding-top: 30px;
  }

  .footmainbox {
    margin: 0px auto;
    width: 690px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .inlineblock {
    display: inline-block;
    vertical-align: top;
  }

  .quanxuanicon {
    font-size: 24px;
    font-family: PingFang;
    font-weight: bold;
    color: #333333;
    margin-left: 20px;
  }

  .deltext {
    font-size: 24px;
    font-family: PingFang;
    font-weight: bold;
    color: #f56c6c;
    margin-left: 20px;
  }

  .zhifulable {
    font-size: 24px;
    font-family: PingFang;
    font-weight: 500;
    color: #000000;
    // margin-left: 50px;
    line-height: 70px;
  }

  .pricefont {
    font-size: 36px;
    font-family: PingFang;
    font-weight: bold;
    color: #000000;
    margin-left: 10px;
    position: relative;
    top: 3px;
  }

  .buybtn {
    width: 160px;
    height: 70px;
    background: #986665;
    line-height: 70px;
    text-align: center;
    font-size: 24px;
    font-family: PingFang;
    font-weight: 500;
    color: #ffffff;
  }

  .editpoptitle {
    text-align: center;
    line-height: 100px;
    font-size: 36px;
    font-family: PingFang;
    font-weight: bold;
    color: #000000;
  }

  .commodityInfobox {
    margin: 0 auto;
    margin-top: 20px;
    width: 690px;
  }

  .commoditytitlebox {
    margin-top: 20px;
    font-size: 30px;
    font-family: PingFang;
    font-weight: bold;
    color: #666666;
  }

  .commoditynamebox {
    margin-top: 20px;
    font-size: 30px;
    font-family: PingFang;
    font-weight: 500;
    color: #333333;
  }

  .commoditytagbox {
    margin-top: 20px;
  }

  .commoditytag {
    display: inline-block;
    vertical-align: top;
    margin: 0px 10px 10px 0px;
    width: fit-content;
    padding: 0 10px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    font-size: 20px;
    font-family: PingFang;
    font-weight: 500;
    color: #7c7d7d;
    border: 1px solid #bbbbbb;
  }

  .pricebox {
    width: 676px;
    padding-left: 14px;
    line-height: 60px;
    height: 60px;

    border: 2px solid #e3e3e3;
  }

  .pricelablebox {
    display: inline-block;
    vertical-align: top;
    width: 205px;
    font-size: 28px;
    font-family: PingFang;
    font-weight: 500;
    color: #333333;
  }

  .pricenumbox {
    display: inline-block;
    vertical-align: top;
    font-size: 28px;
    font-family: Heiti SC;
    font-weight: 500;
    color: #000000;
  }

  .skubox {
    width: 666px;
    padding-left: 14px;
    padding-right: 10px;
    padding-top: 16px;
    line-height: 60px;
    border: 2px solid #e3e3e3;
    border-top: none;
  }

  .marginbuttom10 {
    margin-bottom: 10px;
  }

  .inlinerightbox {
    display: inline-block;
    vertical-align: top;
    width: 460px;
  }

  .editbtnbox {
    margin: 0 auto;
    margin-top: 60px;
    width: 690px;
    height: 80px;
    background: #986665;
    text-align: center;
    line-height: 80px;
    font-size: 26px;
    font-family: PingFang;
    font-weight: bold;
    color: #ffffff;
  }

  .statelable {
    font-size: 28px;
    font-family: PingFang;
    font-weight: 500;
    color: #666666;
  }

  .diafooterbtn {
    margin-top: 30px;
    text-align: center;
  }

  /deep/.el-dialog {
    background-color: #eeeee2;
  }

  //pc
  .zrlzhanwei {
    width: 100%;
    height: 150px;
  }

  .zrllogobox {
    width: 130px;
    height: 48px;
    margin: 0 auto;
  }

  .zrllogoimg {
    width: 130px;
    height: 48px;
  }

  .zrlcategorybox {
    display: flex;
    flex-wrap: wrap;
    border-top: 1px solid #dddddd;
    margin-top: 30px;
  }

  .zrlcategoryitembox {
    width: 148px;
    height: 60px;
    // border-top: 1px solid #dddddd;
    border-right: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 60px;
    text-align: center;
  }

  .zrlcategoryitembox:nth-child(5n) {
    border-right: none;
  }

  .zrlmainbox {
    margin: 0 auto;
    width: 690px;
    margin-top: 37px;
  }

  .zrlmaintitle {
    margin-bottom: 48px;
    font-size: 18px;
    font-family: PingFang;
    font-weight: bold;
    color: #333333;
  }

  .zrlcolor986 {
    color: #986565;
  }

  .zrlmainitembox {
    width: 648px;
    padding: 30px 20px;
    // background: #ffffff;
    // border: 1px solid #dddddd;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-bottom: 20px;
    border-top: 2px solid #222;
  }

  .zrlcheckcionbox {
    width: 32px;
    height: 32px;
    background: #dddddd;
    border-radius: 2px;
  }

  .zrlckeckicon {
    width: 32px;
    height: 32px;
  }

  .zrlmainimg {
    width: 90px;
    height: 90px;
    border-radius: 5px;
    object-fit: cover;
  }

  .zrlmainiteninfobox {
    width: 387px;
    min-height: 90px;
  }

  .zrlinfonamebox {
    font-size: 16px;
    font-family: PingFang;
    font-weight: bold;
    color: #666666;
  }

  .zrlinfotitlebox {
    font-size: 16px;
    font-family: PingFang;
    font-weight: 500;
    color: #000000;
  }

  .zrlskuinfo {
    font-size: 14px;
    font-family: PingFang;
    font-weight: 500;
    color: #999999;
  }

  .zrlskuinfoitem {
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;
  }

  .zrlflexbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .zrlskuinfoprice {
    font-size: 14px;
    font-family: PingFang;
    font-weight: 500;
    color: #000000;
  }

  .zrlflexboxtwo {
    min-height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .zrlfootbox {
    width: 750px;
    height: 60px;
    background: #ffffff;
    box-shadow: 0px -1px 7px 0px rgba(235, 235, 236, 0.42);
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0px;
    padding-top: 10px;
  }

  .zrlfootmainbox {
    margin: 0px auto;
    width: 690px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .zrlinlineblock {
    display: inline-block;
    vertical-align: top;
  }

  .zrlquanxuanicon {
    font-size: 20px;
    font-family: PingFang;
    font-weight: bold;
    color: #333333;
    margin-left: 20px;
  }

  .zrldeltext {
    font-size: 20px;
    font-family: PingFang;
    font-weight: bold;
    color: #f56c6c;
    margin-left: 20px;
  }

  .zrlzhifulable {
    font-size: 20px;
    font-family: PingFang;
    font-weight: 500;
    color: #000000;
    // margin-left: 50px;
    line-height: 50px;
  }

  .zrlpricefont {
    font-size: 30px;
    font-family: PingFang;
    font-weight: bold;
    color: #000000;
    margin-left: 10px;
    position: relative;
    top: 3px;
  }

  .zrlbuybtn {
    width: 160px;
    height: 50px;
    background: #986665;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    font-family: PingFang;
    font-weight: 500;
    color: #ffffff;
  }

  .zrlbox {
    display: none;
  }

  @media screen and (min-width: 1000px) {
    .lg {
      display: none;
    }

    .zrlbox {
      display: block;
    }
  }
</style>